import { colors, darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information common to the login, forgot password and change password pages.
 */
export const AccountPageStyles = makeStyles((theme: Theme) => ({
    root: {},

    loginPageWrapper: {
        height: "100vh",
        display: "flex",
        alignItems: "center",
    },
    submitButton: {
        fontSize: "12px",
        lineHeight: "14px",
        fontWeight: "bold",
        color: "#fff",
        background: "#556ED1",
        letterSpacing: "-0.12px",
        minHeight: "30px",
        padding: "8px 15px",
        borderRadius: "5px",
        boxShadow: "none",
        width: "100%",
    },
    houseImageContainer: {
        height: "100%",
        backgroundImage: "url(resources/loginImage.jpg)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "50%",
    },

    loginPageFormBlock: {
        width: "50%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "50px",
        position: "relative",
        "& > .login-block": {
            width: "100%",
            maxWidth: "264px",
        },
        [theme.breakpoints.down("sm")]: {
            "& > .login-block": {
                width: "100%",
                maxWidth: "350px",
            },
        },
        [theme.breakpoints.down("xs")]: {
            "& > .login-block": {
                width: "100%",
                maxWidth: "100%",
            },
        },
    },
    forgetPassWordRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "20px",
        "& > button": {
            padding: "0",
            textAlign: "end",
            fontSize: "8px",
            lineHeight: "9px",
            color: "#0090DF",
        },
    },
    customFormBlock: {},
    formInputControl: {
        marginBottom: "30px !important",
        "& > div": {
            "& > div": {
                "& > button": {
                    padding: "0",
                    marginRight: "-10px",
                },
            },
        },
        "& > ": {
            marginRight: "-10px",
        },
    },
    labelText: {
        fontSize: "10px",
        lineHeight: "12px",
        fontWeight: "bold",
        letterSpacing: "-0.1px",
        marginBottom: "8px",
        display: "inline-block",
        color: "#4A4A4A",
    },

    error: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    logoImageContainer: {
        height: "38px",
        backgroundImage: "url(resources/LogoLandscape.svg)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        position: "absolute",
        left: "40px",
        bottom: "40px",
        width: "130px",
    },
    strapLine: {
        fontSize: "14px",
        lineHeight: "1.4",
        marginBottom: "35px",
        textAlign: "center",
        color: "#3C3C3B",
    },
    poweredByText: {
        position: "absolute",
        bottom: "100%",
        left: 0,
        marginBottom: "4px",
        fontSize: "10px",
        lineHeight: 1,
        color: "#3C3C3B",
        whiteSpace: "nowrap",
    },
    gutterBottom: {
        marginBottom: "40px",
    },
    title: {
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
        marginTop: "-5px",
        textAlign: "center",
        color: "#3C3C3B",
    },
    subTitle: {
        fontSize: "12px",
        lineHeight: "1.4",
        marginBottom: "16px",
        textAlign: "center",
        color: "#3C3C3B",
    },
    linkButton: {
        fontSize: "10px",
        padding: "16px 6px",
        width: "100%",
        color: "#556ED1",
        textDecoration: "underline",
    },
    mainLogo: {
        margin: "0 auto",
        display: "block",
        marginBottom: "35px",
        maxWidth: "262px",
    },
    [theme.breakpoints.up("md")]: {
        error: {
            "& > div": {
                display: "flex",
                margin: "0 -15px",
                paddingBottom: "10px",
            },
        },

        divider: {
            display: "block",
        },
    },
    [theme.breakpoints.down("sm")]: {
        mainLogo: {
            marginBottom: "10px",
        },
        houseImageContainer: {
            display: "none",
        },
        loginPageFormBlock: {
            width: "100%",
        },
        gutterBottom: {
            marginBottom: "20px",
        },
    },
    [theme.breakpoints.down("xs")]: {
        mainLogo: {
            height: "60px",
        },
        loginPageFormBlock: {
            padding: "30px",
        },
        logoImageContainer: {
            left: "30px",
            width: "105px",
            bottom: "30px",
            height: "30px",
        },
        formInputControl: {
            marginBottom: "16px !important",
        },
        forgetPassWordRow: {
            marginBottom: "20px !important",
        },
    },
}));

/**
 * Contains style information for the login page.
 */
export const LoginPageStyles = makeStyles((theme: Theme) => ({
    root: {},
    linkButton: {
        fontSize: "10px",
        padding: "16px 6px",
        width: "65px",
        color: "#556ED1",
        textDecoration: "underline",
    },
}));

/**
 * Contains style information for the forgot password page.
 */
export const ForgotPasswordPageStyles = makeStyles((theme: Theme) => ({
    root: {
        // "& > .forgetPasswordFormBlock": {
        //     width: "100%",
        //     maxWidth: "400px",
        //     margin: "0 auto",
        //     minHeight: "100vh",
        //     display: "flex",
        //     alignItems: "center",
        //     flexDirection: "column",
        //     justifyContent: "center",
        //     padding: "30px",
        // },
    },
    forgetPasswordFormBlock: {
        width: "100%",
        maxWidth: "400px",
        margin: "0 auto",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        padding: "30px",
    },
    mainLogo: {
        marginBottom: "20px",
        maxWidth: "262px",
    },
    inputBox: {
        marginTop: "30px",
    },
    [theme.breakpoints.down("sm")]: {},
}));

/**
 * Contains style information for the change password page.
 */
export const ChangePasswordPageStyles = makeStyles((theme: Theme) => ({
    root: {},
}));
